import getCombatantSlots from './getCombatantSlots'

export default async function getCombatantNextRoundMarker(combatant, round) {
  if (!combatant?.slug || !Number.isFinite(round)) {
    return null
  }

  const slots = await getCombatantSlots(combatant.slug)
  const nextRound = round + 1
  const markers = Array.isArray(slots?.markers) ? slots.markers : []

  const nextMarker = markers
    .filter(
      (marker) =>
        marker?.round === nextRound &&
        Number.isFinite(marker?.number) &&
        marker?.marker_name !== 'pending' &&
        marker?.marker_name !== 'blank',
    )
    .sort((left, right) => left.number - right.number)[0]

  return nextMarker || null
}
